import { render, staticRenderFns } from "./HostingApps.vue?vue&type=template&id=286d510a&"
import script from "./HostingApps.vue?vue&type=script&lang=js&"
export * from "./HostingApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports